import { render, staticRenderFns } from "./Datasets.vue?vue&type=template&id=687d1844"
import script from "./Datasets.vue?vue&type=script&lang=js"
export * from "./Datasets.vue?vue&type=script&lang=js"
import style0 from "./Datasets.vue?vue&type=style&index=0&id=687d1844&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports